module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wYBZ7x/tc-custom/9781685505240.jpg?1718282659476",
      "alt": "This image is the cover for the book Restaurant Wars"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Restaurant Wars\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Thomas MaCaffrey never expected to see his high school crush, Noah Petrie, again, let alone have him working at the same restaurant as Thomas."), _c('br'), _c('br'), _vm._v("They grew up together on the same street as kids and in high school Noah was a popular quarterback who barely noticed Thomas was alive."), _c('br'), _c('br'), _vm._v("Noah is hotter than ever and just as annoying, ingratiating himself with the staff and patrons alike. But when Noah becomes the restaurant’s new darling, the war is on. And when Noah makes it clear he’s pursuing Thomas, the war might be for his heart.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Shawn Lane\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0